import React, { useState, useContext } from 'react';
import TeacherTable from '../components/exl/TeacherTable'
import ErrorPage from './error';
import { DataContext } from '../store';
import Toasts from '../components/crm/shared/Toasts';
import ExlToasts from '../components/crm/shared/ExlToasts';


const ExlTeachers = () => {
    const {
        store: { user },
    } = useContext(DataContext);
    const [error] = useState(null);
    return (error || !user || !(user.isExlAdmin || user.isAdmin)) ? (
        <ErrorPage error={error} />
    ) : (
        <>
            <TeacherTable />
            <ExlToasts />
        </>
    );
};

export default ExlTeachers;

